import { useEffect, useMemo } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { LoaderProgress } from "components/icon/loaderProgress.component";
import { isStaffingModuleEnabled } from "model/settings.logic";
import { useAuthStore } from "stores/authStore/authStore";
import { ApplicationList } from "web-apps/company/components/applications/applicationList.component";
import { useApplicationStore } from "web-apps/company/stores/applicationStore/applicationStore";
import { useCompanyStore } from "web-apps/company/stores/companyStore/companyStore";

export const ApplicationPage = (): JSX.Element => {
  const [authState] = useAuthStore();
  const [companyState] = useCompanyStore();
  const [applicationState] = useApplicationStore();
  const history = useHistory();
  const location = useLocation();

  const hasStaffingModule = useMemo(
    () => isStaffingModuleEnabled(companyState.companySettings),
    [companyState.companySettings],
  );

  useEffect(() => {
    if (hasStaffingModule) return;

    const params = new URLSearchParams(location.search);
    params.set("page", "Subscription");

    history.replace({
      pathname: location.pathname,
      search: params.toString(),
    });
  }, [hasStaffingModule, history, location.pathname, location.search]);

  return authState.isLoading ||
    companyState.isLoading ||
    applicationState.isLoading ? (
    <LoaderProgress />
  ) : (
    <ApplicationList />
  );
};
